import React from "react";
import {
    Alarm,
    AlarmFill,
    BarChartFill,
    Box,
    BoxArrowInUp,
    BoxFill, Bug,
    HourglassSplit, Inboxes, InboxesFill,
    PersonLinesFill,
    TagsFill
} from "react-bootstrap-icons";
import {Dictionary} from "../../components/Dictionary";
import {XHR} from "../../components/XHR";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {FormattedNumberDiff} from "../../components/Elements/FormattedNumberDiff";

export class MainPage extends React.Component<any, any> {

    protected dictionary: Dictionary = new Dictionary();
    protected request: XHR = new XHR();
    private tableHeadInit: boolean = false;
    private requestInProgress: boolean = false;

    componentDidMount() {
        this.request.fetch('/order/info-main', {
            type: this.getTypeOfStat(),
            year: this.getCurrentYear(),
            halfYear: this.getCurrentHalfYear(),
            month: this.getCurrentMonth(),
            week: this.getCurrentWeek(),
            day: this.getCurrentDay(),
        }, {method: 'POST'})
            .then((state: { item: { [key: string]: string } } | any) => {
                this.setState(state, () => {
                    this.sortTableViaHead();
                });
            }).catch(error => {
            this.onError(error);
        });
    }

    render() {
        if (!this.state) {
            return (
                <div className={'loveable'}>
                    <div className={'container-fluid'}>
                        <div className={'row'}>{this.head(true)}</div>
                    </div>
                </div>
            );
        }

        const state = this.state;
        let top5clientIndex: number = 0;
        let top5productIndex: number = 0;
        let top5B2BproductIndex: number = 0;
        let top5B2CproductIndex: number = 0;
        // const dictionary = this.dictionary;

        return (
            <div className={'loveable'}>
                <div className={'container-fluid'}>
                    {this.head(false)}
                    <div className={'row'}>
                        <h4 className={'lineSeparator first-child'}>Volumen és forgalom</h4>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">
                                    Kimenő forgalom
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.all || '')}
                                        {/*<small>db csomag</small>*/}
                                        <FormattedNumberDiff value={this.state.item.all_diff}/>
                                    </h3>

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">db csomag</p>

                                <div className="mainIcon">
                                    <BoxFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">
                                    Kimenő forgalom (B2C)
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.allb2c || '')}
                                        {/*<small>db csomag</small>*/}
                                        <FormattedNumberDiff value={this.state.item.allb2c_diff}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.allb2b || '')} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.allb2c || '')}*/}
                                    db csomag
                                </p>

                                <div className="mainIcon">
                                    <BoxFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">
                                    Kimenő forgalom (B2B)
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.allb2b || '')}
                                        {/*<small>db csomag</small>*/}
                                        <FormattedNumberDiff value={this.state.item.allb2b_diff}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.allb2b || '')} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.allb2c || '')}*/}
                                    db megrendelés
                                </p>

                                <div className="mainIcon">
                                    <BoxFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Beérkező forgalom </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.incoming_products || '')}
                                        {/*<small>db termék</small>*/}
                                        <FormattedNumberDiff value={this.state.item.incoming_products_diff}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal fw-normal">
                                    db termék
                                    ~= {FormattedNumber.formatIf(this.state.item.incoming_products_carton || '')} db
                                    karton
                                </p>

                                <div className="mainIcon">
                                    <BoxArrowInUp color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Átlagos rendelésméret </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.all_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.all_avg_size_product_count || '', 2)}
                                        {/*<small>SKU / termék</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.allb2b_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2b_avg_size_product_count || '', 2)}*/}
                                    {/*&nbsp;|&nbsp;*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.allb2c_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2c_avg_size_product_count || '', 2)}*/}
                                    SKU / termék
                                </p>

                                <div className="mainIcon">
                                    <Box color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Átlagos rendelésméret (B2C)</p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.allb2c_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2c_avg_size_product_count || '', 2)}
                                        {/*<small>SKU / termék</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.allb2b_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2b_avg_size_product_count || '', 2)}*/}
                                    {/*&nbsp;|&nbsp;*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.allb2c_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2c_avg_size_product_count || '', 2)}*/}
                                    SKU / termék
                                </p>

                                <div className="mainIcon">
                                    <Box color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Átlagos rendelésméret (B2B)</p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.allb2b_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2b_avg_size_product_count || '', 2)}
                                        {/*<small>SKU / termék</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.allb2b_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2b_avg_size_product_count || '', 2)}*/}
                                    {/*&nbsp;|&nbsp;*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.allb2c_avg_size_item_count || '', 2)}&nbsp;/&nbsp;{FormattedNumber.formatIf(this.state.item.allb2c_avg_size_product_count || '', 2)}*/}
                                    SKU / termék
                                </p>

                                <div className="mainIcon">
                                    <Box color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Raktárkészlet állomány </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.warehouse_products_quantity || '')}
                                        <small>db</small>
                                        <FormattedNumberDiff value={this.state.item.warehouse_products_quantity_diff}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    készletérték:
                                    ~{FormattedNumber.formatIf(this.state.item.warehouse_products_price || '')} €
                                </p>

                                <div className="mainIcon">
                                    <BarChartFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>


                        <h4 className={'lineSeparator'}>Hatékonyság és termelékenység</h4>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Order lead time<br/>
                                    <small>
                                        rendelés beérkezésétől a kiszállításig eltelt
                                        átlagos idő
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.order_lead_avg || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                        <FormattedNumberDiff value={this.state.item.order_lead_avg_diff} revert={true}/>
                                    </h3>
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.order_lead_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.order_lead_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <HourglassSplit color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Order lead time (B2B)<br/>
                                    <small>
                                        rendelés beérkezésétől a kiszállításig eltelt
                                        átlagos idő
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.order_lead_avg_b2b || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                        <FormattedNumberDiff value={this.state.item.order_lead_avg_b2b_diff}
                                                             revert={true}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.order_lead_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.order_lead_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <HourglassSplit color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Order lead time (B2C)<br/>
                                    <small>
                                        rendelés beérkezésétől a kiszállításig eltelt
                                        átlagos idő
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.order_lead_avg_b2c || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                        <FormattedNumberDiff value={this.state.item.order_lead_avg_b2c_diff}
                                                             revert={true}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                </p>

                                <div className="mainIcon">
                                    <HourglassSplit color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Picker/packer teljesítmény<br/>
                                    <small>
                                        <strong>műszakonként</strong> feldolgozott termékek száma
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.picker_packer_avg || '', 2)}
                                        <small>termék műszakonként</small>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    B2B: {FormattedNumber.formatIf(this.state.item.picker_packer_avg_b2b || '', 2)} |
                                    B2C: {FormattedNumber.formatIf(this.state.item.picker_packer_avg_b2c || '', 2)}
                                </p>
                                <div className="mainIcon">
                                    <AlarmFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Picker/packer teljesítmény<br/>
                                    <small>
                                        <strong>óránként</strong> feldolgozott termékek száma
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.picker_packer_hourly_avg || '', 2)}
                                        <small>termék óránként</small>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    B2B: {FormattedNumber.formatIf(this.state.item.picker_packer_hourly_avg_b2b || '', 2)} |
                                    B2C: {FormattedNumber.formatIf(this.state.item.picker_packer_hourly_avg_b2c || '', 2)}
                                </p>

                                <div className="mainIcon">
                                    <AlarmFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Picking time<br/>
                                    <small>
                                        Átlagos pickelési idő rendelésenként
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.picking_avg || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.picking_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.picking_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <Inboxes color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Picking time (B2B)<br/>
                                    <small>
                                        Átlagos pickelési idő rendelésenként
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.picking_avg_b2b || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.picking_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.picking_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <Inboxes color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Picking time (B2C)<br/>
                                    <small>
                                        Átlagos pickelési idő rendelésenként
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.picking_avg_b2c || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.picking_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.picking_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <Inboxes color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Packing time<br/>
                                    <small>
                                        Átlagos csomagolási idő rendelésenként
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.packing_avg || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.packing_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.packing_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <InboxesFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Packing time (B2B)<br/>
                                    <small>
                                        Átlagos csomagolási idő rendelésenként
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.packing_avg_b2b || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.packing_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.packing_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <InboxesFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText">Packing time (B2C)<br/>
                                    <small>
                                        Átlagos csomagolási idő rendelésenként
                                    </small>
                                </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.packing_avg_b2c || '', 2)}
                                        {/*<small>óra átlag</small>*/}
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}

                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    óra átlag
                                    {/*B2B: {FormattedNumber.formatIf(this.state.item.packing_avg_b2b || '', 2)} |*/}
                                    {/*B2C: {FormattedNumber.formatIf(this.state.item.packing_avg_b2c || '', 2)}*/}
                                </p>

                                <div className="mainIcon">
                                    <InboxesFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>


                        <h4 className={'lineSeparator'}>Minőség és hibaarányok</h4>


                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Hibátlanul kiküldött rendelések </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.ordersShippedWithoutErrors * 100, 2)}
                                        <small>%</small>
                                        <FormattedNumberDiff value={this.state.item.ordersShippedWithoutErrors_diff}/>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    {FormattedNumber.formatIf(this.state.item.orderProductsShippedWithoutErrors * 100, 2)}
                                    <span style={{fontWeight: 400}}>% B2B megrendelés tételek</span>
                                </p>
                                <div className="mainIcon">
                                    <Bug color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>


                        <h4 className={'lineSeparator'}>Költségek és erőforrások</h4>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Munkaóra / csomag </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.wt_per_packet_all || '', 2)}
                                        <small>óra átlag</small>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    B2B: {FormattedNumber.formatIf(this.state.item.wt_per_packet_allb2b || '', 2)} |
                                    B2C: {FormattedNumber.formatIf(this.state.item.wt_per_packet_allb2c || '', 2)}
                                </p>

                                <div className="mainIcon">
                                    <Alarm color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <div className="mainCard">
                                <p className="mainText"> Összes munkaóra </p>
                                <div className="flex items-baseline gap-2">
                                    <h3 className="text-3xl font-bold tracking-tight">
                                        {FormattedNumber.formatIf(this.state.item.wt_all || '', 2)}
                                        <small> óra </small>
                                    </h3>
                                    {/*<span className="text-sm font-medium text-success">↑ 12.5%</span>*/}
                                </div>
                                <p className="text-xs text-muted-foreground mt-1 fw-normal">
                                    B2B: {FormattedNumber.formatIf(this.state.item.wt_allb2b || '', 2)} |
                                    B2C: {FormattedNumber.formatIf(this.state.item.wt_allb2c || '', 2)}
                                </p>

                                <div className="mainIcon">
                                    <Alarm color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={'row'}>

                        <h4 className={'lineSeparator'}>Stratégiai szint</h4>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="mainCard">
                                <p className="mainText">Top 10 B2B ügyfél</p>
                                <table className="table table-hover table-sm align-middle">
                                    <thead>
                                    <tr>
                                        <th className="sortable">Név</th>
                                        <th className="sortable">Rendelések</th>
                                        <th className="sortable">Termékek
                                            <i className="bi bi bi-sort-down"></i>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {state.item.top5client.map(function (elem: any) {
                                        let props = {style: {}};
                                        top5clientIndex++;
                                        if (10 < top5clientIndex) {
                                            props.style = {display: 'none'};
                                        } else {
                                            props.style = {display: 'table-row'};
                                        }
                                        return (
                                            <tr key={'top5client' + elem.id} {...props}>
                                                <td>{elem.shipping_name}</td>
                                                <td data-value={elem.count || '0'}>{FormattedNumber.format(elem.count || '')} db</td>
                                                <td data-value={elem.product_count || '0'}>{FormattedNumber.format(elem.product_count || '')} db</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                                <div className="mainIcon">
                                    <PersonLinesFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="mainCard">
                                <p className="mainText">Top 10 termék</p>
                                <table className="table table-hover table-sm align-middle">
                                    <thead>
                                    <tr>
                                        <th className="sortable">Termék</th>
                                        <th className="sortable">Rendelések</th>
                                        <th className="sortable">Termékek
                                            <i className="bi bi bi-sort-down"></i>
                                        </th>
                                        <th className="sortable">Egységár</th>
                                        <th className="sortable">Összesen</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {state.item.top5product.map(function (elem: any) {
                                        let props = {style: {}};
                                        top5productIndex++;
                                        if (10 < top5productIndex) {
                                            props.style = {display: 'none'};
                                        } else {
                                            props.style = {display: 'table-row'};
                                        }
                                        return (
                                            <tr key={'top5product.' + elem.id} {...props}>
                                                <td>{elem.product_name}</td>
                                                <td data-value={elem.order_count || '0'}>{FormattedNumber.format(elem.order_count || '')} db</td>
                                                <td data-value={elem.product_quantity || '0'}>{FormattedNumber.format(elem.product_quantity || '')} db</td>
                                                <td data-value={elem.unit_cost || '0'}>{FormattedNumber.format(elem.unit_cost || '', 2)} €</td>
                                                <td data-value={elem.total_cost || '0'}>{FormattedNumber.format(elem.total_cost || '', 2)} €</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                                <div className="mainIcon">
                                    <TagsFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="mainCard">
                                <p className="mainText">Top 10 B2B termék</p>
                                <table className="table table-hover table-sm align-middle">
                                    <thead>
                                    <tr>
                                        <th className="sortable">Termék</th>
                                        <th className="sortable">Rendelések</th>
                                        <th className="sortable">Termékek
                                            <i className="bi bi bi-sort-down"></i>
                                        </th>
                                        <th className="sortable">Egységár</th>
                                        <th className="sortable">Összesen</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {state.item.top5B2Bproduct.map(function (elem: any) {
                                        let props = {style: {}};
                                        top5B2BproductIndex++;
                                        if (10 < top5B2BproductIndex) {
                                            props.style = {display: 'none'};
                                        } else {
                                            props.style = {display: 'table-row'};
                                        }
                                        return (
                                            <tr key={'top5B2Bproduct.' + elem.id} {...props}>
                                                <td>{elem.product_name}</td>
                                                <td data-value={elem.order_count || '0'}>{FormattedNumber.format(elem.order_count || '')} db</td>
                                                <td data-value={elem.product_quantity || '0'}>{FormattedNumber.format(elem.product_quantity || '')} db</td>
                                                <td data-value={elem.unit_cost || '0'}>{FormattedNumber.format(elem.unit_cost || '', 2)} €</td>
                                                <td data-value={elem.total_cost || '0'}>{FormattedNumber.format(elem.total_cost || '', 2)} €</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                                <div className="mainIcon">
                                    <TagsFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="mainCard">
                                <p className="mainText">Top 10 B2C termék</p>
                                <table className="table table-hover table-sm align-middle">
                                    <thead>
                                    <tr>
                                        <th className="sortable">Termék</th>
                                        <th className="sortable">Rendelések</th>
                                        <th className="sortable">Termékek
                                            <i className="bi bi bi-sort-down"></i>
                                        </th>
                                        <th className="sortable">Egységár</th>
                                        <th className="sortable">Összesen</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {state.item.top5B2Cproduct.map(function (elem: any) {
                                        let props = {style: {}};
                                        top5B2CproductIndex++;
                                        if (10 < top5B2CproductIndex) {
                                            props.style = {display: 'none'};
                                        } else {
                                            props.style = {display: 'table-row'};
                                        }
                                        return (
                                            <tr key={'top5B2Cproduct.' + elem.id} {...props}>
                                                <td>{elem.product_name}</td>
                                                <td data-value={elem.order_count || '0'}>{FormattedNumber.format(elem.order_count || '')} db</td>
                                                <td data-value={elem.product_quantity || '0'}>{FormattedNumber.format(elem.product_quantity || '')} db</td>
                                                <td data-value={elem.unit_cost || '0'}>{FormattedNumber.format(elem.unit_cost || '', 2)} €</td>
                                                <td data-value={elem.total_cost || '0'}>{FormattedNumber.format(elem.total_cost || '', 2)} €</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                                <div className="mainIcon">
                                    <TagsFill color={'#2662d9'} fontSize={'24px'}/>
                                </div>
                            </div>
                        </div>

                        <p className={'hidden'}>
                            https://pack-dash-pro.lovable.app/<br/>
                            1. Volumen és forgalom<br/>
                            Kimenő forgalom: napi/heti/havi összes csomag (külön B2B és B2C bontásban)<br/>
                            Beérkező forgalom: beszállított termékek darabszáma, raklap száma <br/>
                            Átlagos rendelésméret: hány tétel/csomag B2B és B2C esetén<br/>
                            Raktárkészlet állomány: készletérték, darabszám, forgási sebesség<br/>
                            <br/>
                            <br/>
                            2. Hatékonyság és termelékenység<br/>
                            Order lead time: rendelés beérkezésétől a kiszállításig eltelt átlagos idő<br/>
                            Picker/packer teljesítmény: óránként / műszakonként feldolgozott tételek száma<br/>
                            Átlagos pickelési idő rendelésenként<br/>
                            Átlagos csomagolási idő rendelésenként<br/>
                            Munkatársak hatékonysága: kimenő csomag / dolgozó / nap<br/>
                            <br/>
                            <br/>
                            3. Minőség és hibaarányok<br/>
                            Order accuracy: hibátlanul kiküldött rendelések aránya (%)<br/>
                            Return rate: visszaküldött csomagok aránya és oka (hiba, sérülés, vásárlói ok)<br/>
                            Damage rate: sérült termékek aránya a kiszállításban<br/>
                            <br/>
                            <br/>
                            4. Költségek és erőforrások<br/>
                            Költség per csomag (B2B és B2C külön)<br/>
                            Munkaóra ráfordítás per csomag<br/>
                            Raktári munkaerő kihasználtság (dolgozók száma vs. kapacitás)<br/>
                            Anyagfelhasználás: csomagolóanyag költség/csomag<br/>
                            <br/>
                            <br/>
                            5. SLA és ügyfélélmény<br/>
                            Időben kiszállított rendelések aránya (OTD – On Time Delivery %)<br/>
                            Késedelmes kiszállítások száma és aránya<br/>
                            Átlagos szállítási idő B2B és B2C esetén<br/>
                            Vevői reklamációk száma/típusa<br/>
                            <br/>
                            <br/>
                            6. Stratégiai szint<br/>
                            Top 10 vevő rendelés volumene (B2B)<br/>
                            Top 10 termék/sku forgalom szerint<br/>
                            Készlet forgási napok (DOI – Days of Inventory)<br/>
                            Szezonális ingadozások, trendek<br/>
                        </p>

                    </div>
                </div>
            </div>
        );
    };

    protected onError(error: any, event: SubmitEvent | null = null) {
        if (event && event.target instanceof HTMLFormElement && event.target.querySelector('.alert.alert-danger')) {
            (event.target.querySelector('.alert.alert-danger') as HTMLElement).innerHTML = error.message;
            (event.target.querySelector('.alert.alert-danger') as HTMLElement).classList.remove('hide');
            return;
        }

        if (document.querySelector('form .alert.alert-danger')) {
            (document.querySelector('form .alert.alert-danger') as HTMLElement).innerHTML = error.message;
            (document.querySelector('form .alert.alert-danger') as HTMLElement).classList.remove('hide');
            return;
        }

        console.error(error);
    }

    private getTypeOfStat(): string {
        if (window.location.pathname.includes('daily')) {
            return 'daily';
        }
        if (window.location.pathname.includes('weekly')) {
            return 'weekly';
        }
        if (window.location.pathname.includes('monthly')) {
            return 'monthly';
        }
        if (window.location.pathname.includes('halfYearly')) {
            return 'halfYearly';
        }
        if (window.location.pathname.includes('yearly')) {
            return 'yearly';
        }
        return 'all';
    }

    private typeOfStat(): string {
        const typeOfStat = this.getTypeOfStat();
        if (typeOfStat === 'daily') {
            return 'Napi áttekintő';
        }
        if (typeOfStat === 'weekly') {
            return 'Heti áttekintő';
        }
        if (typeOfStat === 'monthly') {
            return 'Havi áttekintő';
        }
        if (typeOfStat === 'halfYearly') {
            return 'Féléves áttekintő';
        }
        if (typeOfStat === 'yearly') {
            return 'Éves áttekintő';
        }
        return 'Mindenkori áttekintő';
    }

    private head(loading: boolean) {

        const self = this;
        // const {isoYear, weekNo} = this.getISOWeek(new Date());

        // const yearlyLink = '/stats/yearly/' + this.getCurrentYear();
        // const halfYearlyLink = '/stats/halfYearly/' + this.getCurrentYear() + '/' + this.getCurrentHalfYear();
        // const monthlyLink = '/stats/monthly/' + this.getCurrentYear() + '/' + this.getCurrentMonth();
        // const weeklyLink = '/stats/weekly/' + isoYear + '/' + weekNo;
        // const dailyLink = '/stats/daily/' + isoYear + '/' + weekNo;

        return (<div className={'row'}>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <h3>Raktár Dashboard</h3>
                <h4>
                    <strong>{this.typeOfStat()}</strong> átfogó áttekintés a raktári teljesítményről
                    {((this.state || null) && this.state.nfo && this.state.nfo.startDate) &&
                        <span><br/>{this.state.nfo.startDate.substring(0, 10).replace('-', '.').replace('-', '.')}. - {this.state.nfo.endDate.substring(0, 10).replace('-', '.').replace('-', '.')}.</span>
                    }
                </h4>
            </div>

            {/*<div className="col-12 col-sm-12 col-md-12 col-lg-12">*/}
            {/*    <nav className={'typeOfStatSelector nav nav-pills nav-fill'}>*/}
            {/*        <a className={this.getTypeOfStat() === 'all' ? 'nav-link active' : 'nav-link'} href={'/stats/all'}>*/}
            {/*            Mindenkori áttekintő*/}
            {/*        </a>*/}
            {/*        <a className={this.getTypeOfStat() === 'yearly' ? 'nav-link active' : 'nav-link'} href={yearlyLink}>*/}
            {/*            Éves áttekintő*/}
            {/*        </a>*/}
            {/*        <a className={this.getTypeOfStat() === 'halfYearly' ? 'nav-link active' : 'nav-link'}*/}
            {/*           href={halfYearlyLink}>*/}
            {/*            Féléves áttekintő*/}
            {/*        </a>*/}
            {/*        <a className={this.getTypeOfStat() === 'monthly' ? 'nav-link active' : 'nav-link'}*/}
            {/*           href={monthlyLink}>*/}
            {/*            Havi áttekintő*/}
            {/*        </a>*/}
            {/*        <a className={this.getTypeOfStat() === 'weekly' ? 'nav-link active' : 'nav-link'} href={weeklyLink}>*/}
            {/*            Heti áttekintő*/}
            {/*        </a>*/}
            {/*        /!*{this.getTypeOfStat() !== 'daily' && <a href={dailyLink}>Napi áttekintő</a>}*!/*/}
            {/*    </nav>*/}
            {/*</div>*/}

            <h4 className="lineSeparator first-child">Mindenkori, éves, féléves és havi nézetek</h4>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12" key={'statsHead'}>

                <nav className={'typeOfStatSelector nav nav-pills nav-fill'} key={'nav-0'}>
                    <a key={'stats-export-all'}
                       className="btn btn-sm btn-outline-primary"
                       rel="noreferrer"
                       href={process.env.REACT_APP_API_URL + `/order/stats/export`} target="_blank">
                        Export
                    </a>
                </nav>

                <span className={'btnSeparator'} key={'btnSeparator-0'}>|</span>

                <nav className={'typeOfStatSelector nav nav-pills nav-fill'} key={'nav-1'}>
                    <a key={'stats-all'}
                       className={self.getTypeOfStat() === 'all' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'}
                       href={`/stats/all`}>
                        All
                    </a>
                </nav>
                <span className={'btnSeparator'} key={'btnSeparator-1'}>|</span>
                <nav className={'typeOfStatSelector nav nav-pills nav-fill'} key={'nav-2'}>
                    {Array.from({length: new Date().getFullYear() - 2025 + 1}, (_, i) => 2025 + i).map(function (year) {
                        return (<>
                            <a key={'year-' + year}
                               className={(self.getTypeOfStat() !== 'all' && self.getCurrentYear() === year) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'}
                               href={`/stats/yearly/${year}`}>
                                {year}
                            </a>
                        </>)
                    })}
                </nav>
                {/*</div>*/}
                <span className={'btnSeparator'} key={'btnSeparator-2'}>|</span>
                {/*<div className="col-12 col-sm-12 col-md-12 col-lg-12">*/}
                <nav className={'typeOfStatSelector nav nav-pills nav-fill'} key={'nav-3'}>
                    <a key={self.getCurrentYear() + 'H1'}
                       className={(self.getTypeOfStat() === 'halfYearly' && this.getCurrentHalfYear() === 'H1') ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'}
                       href={`/stats/halfYearly/${self.getCurrentYear()}/H1`}>
                        H1
                    </a>
                    <a key={self.getCurrentYear() + 'H2'}
                       className={(self.getTypeOfStat() === 'halfYearly' && this.getCurrentHalfYear() === 'H2') ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'}
                       href={`/stats/halfYearly/${self.getCurrentYear()}/H2`}>
                        H2
                    </a>
                </nav>
                {/*</div>*/}
                <span className={'btnSeparator'} key={'btnSeparator-3'}>|</span>
                {/*<div className="col-12 col-sm-12 col-md-12 col-lg-12">*/}
                <nav className={'typeOfStatSelector nav nav-pills nav-fill'} key={'nav-4'}>
                    {this.getMonthsForSelect().map(function (month) {
                        return (<>
                                {/*<OverlayTrigger*/}
                                {/*    delay={{hide: 450, show: 300}}*/}
                                {/*    overlay={(props) => (*/}
                                {/*        <Tooltip {...props} text={'Hii, I am a simple tooltip information!!!'}>*/}
                                {/*            Hii, I am a simple tooltip information!!!*/}
                                {/*        </Tooltip>*/}
                                {/*    )}*/}
                                {/*    placement="bottom"*/}
                                {/*>*/}
                                <a key={month}
                                   className={(self.getTypeOfStat() === 'monthly' && self.getCurrentMonth() === month) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'}
                                   href={`/stats/monthly/${self.getCurrentYear()}/${month}`}
                                   data-bs-toggle="tooltip" data-bs-placement="top"
                                   data-bs-custom-class="custom-tooltip"
                                   data-bs-title="This top tooltip is themed via CSS variables.">
                                    M{month}
                                </a>
                                {/*</OverlayTrigger>*/}
                            </>
                        )
                    })}
                </nav>
            </div>
            <h4 className="lineSeparator first-child">Heti nézetek</h4>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <nav className={'typeOfStatSelector nav nav-pills nav-fill weeklyLinks'} key={'nav-5'}>
                    {this.getWeeksForSelect().map(function (week) {
                        return (<>
                                <a key={week}
                                   className={(self.getTypeOfStat() === 'weekly' && self.getCurrentWeek() === week) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-outline-primary'}
                                   href={`/stats/weekly/${self.getCurrentYear()}/${week}`}>
                                    {week}
                                </a>
                            </>
                        )
                    })}
                </nav>
            </div>

            {/*<div className="col-12 col-sm-12 col-md-6 col-lg-6">*/}
            {/*    {(*/}
            {/*        this.getTypeOfStat() === 'yearly' ||*/}
            {/*        this.getTypeOfStat() === 'halfYearly' ||*/}
            {/*        this.getTypeOfStat() === 'monthly' ||*/}
            {/*        this.getTypeOfStat() === 'weekly' ||*/}
            {/*        this.getTypeOfStat() === 'daily'*/}
            {/*    ) && <FormGroup.Select {...{*/}
            {/*        id: 'year',*/}
            {/*        onChange: () => {*/}
            {/*            if (this.getTypeOfStat() === 'yearly') {*/}
            {/*                window.location.assign('/stats/yearly/' + this.getCurrentYear());*/}
            {/*            }*/}
            {/*            if (this.getTypeOfStat() === 'halfYearly') {*/}
            {/*                window.location.assign('/stats/halfYearly/' + this.getCurrentYear() + '/' + this.getCurrentHalfYear());*/}
            {/*            }*/}
            {/*            if (this.getTypeOfStat() === 'monthly') {*/}
            {/*                window.location.assign('/stats/monthly/' + this.getCurrentYear() + '/' + this.getCurrentMonth());*/}
            {/*            }*/}
            {/*            if (this.getTypeOfStat() === 'weekly') {*/}
            {/*                window.location.assign('/stats/weekly/' + this.getCurrentYear() + '/' + this.getCurrentWeek());*/}
            {/*            }*/}
            {/*            if (this.getTypeOfStat() === 'daily') {*/}
            {/*                window.location.assign('/stats/daily/' + this.getCurrentYear() + '/' + this.getCurrentDay());*/}
            {/*            }*/}
            {/*        },*/}
            {/*        items: this.getYearsForSelect(),*/}
            {/*        defaultValue: this.getCurrentYear(false)*/}
            {/*    }}/>}*/}
            {/*</div>*/}

            {/*<div className="col-12 col-sm-12 col-md-6 col-lg-6">*/}
            {/*    /!*{(this.getTypeOfStat() === 'daily') && <FormGroup.Select {...{*!/*/}
            {/*    /!*    id: 'day',*!/*/}
            {/*    /!*    onChange: () => {*!/*/}
            {/*    /!*        window.location.assign('/stats/daily/' + this.getCurrentYear() + '/' + this.getCurrentDay());*!/*/}
            {/*    /!*    },*!/*/}
            {/*    /!*    items: this.getDaysForSelect(),*!/*/}
            {/*    /!*    defaultValue: this.getCurrentDay(false)*!/*/}
            {/*    /!*}}/>}*!/*/}

            {/*    {(this.getTypeOfStat() === 'weekly') && <FormGroup.Select {...{*/}
            {/*        id: 'week',*/}
            {/*        onChange: () => {*/}
            {/*            window.location.assign('/stats/weekly/' + this.getCurrentYear() + '/' + this.getCurrentWeek());*/}
            {/*        },*/}
            {/*        items: this.getWeeksForSelect(),*/}
            {/*        defaultValue: this.getCurrentWeek(false)*/}
            {/*    }}/>}*/}

            {/*    {(this.getTypeOfStat() === 'monthly') && <FormGroup.Select {...{*/}
            {/*        id: 'month',*/}
            {/*        onChange: () => {*/}
            {/*            window.location.assign('/stats/monthly/' + this.getCurrentYear() + '/' + this.getCurrentMonth());*/}
            {/*        },*/}
            {/*        items: Array.from({length: 12}, (_, i) => 1 + i),*/}
            {/*        defaultValue: this.getCurrentMonth(false)*/}
            {/*    }}/>}*/}

            {/*    {(this.getTypeOfStat() === 'halfYearly') && <FormGroup.Select {...{*/}
            {/*        id: 'halfYear',*/}
            {/*        onChange: () => {*/}
            {/*            window.location.assign('/stats/halfYearly/' + this.getCurrentYear() + '/' + this.getCurrentHalfYear());*/}
            {/*        },*/}
            {/*        items: ['H1', 'H2'],*/}
            {/*        defaultValue: this.getCurrentHalfYear(false)*/}
            {/*    }}/>}*/}
            {/*</div>*/}

            {loading && <h4 className={'lineSeparator first-child'}>Loading...</h4>}
        </div>);
    }

    private getCurrentYear(useInput: boolean = true): number {
        // if (useInput && document.querySelector('select#year')) {
        //     const y = parseInt((document.querySelector('select#year') as HTMLSelectElement).value, 10);
        //     if (isNaN(y)) {
        //         return new Date().getFullYear();
        //     }
        //     return y;
        // }
        const year = window.location.pathname.split('/')[3];
        if (typeof year !== 'undefined') {
            const y = parseInt(year, 10);
            if (isNaN(y)) {
                return new Date().getFullYear();
            }
            return y;
        }
        return new Date().getFullYear();
    }

    private getCurrentHalfYear(useInput: boolean = true): "H2" | "H1" {
        // if (useInput && document.querySelector('select#halfYear')) {
        //     return (document.querySelector('select#halfYear') as HTMLSelectElement).value === 'H1' ? 'H1' : 'H2';
        // }
        if (this.getTypeOfStat() === 'halfYearly') {
            const halfYear = window.location.pathname.split('/')[4];
            if (halfYear === 'H1' || halfYear === 'H2') {
                return halfYear;
            }
        }
        return (6 < new Date().getMonth() + 1) ? 'H2' : 'H1';
    }

    private getCurrentMonth(useInput: boolean = true): number {
        // if (useInput && document.querySelector('select#month')) {
        //     return parseInt((document.querySelector('select#month') as HTMLSelectElement).value, 10);
        // }

        if (this.getTypeOfStat() === 'monthly') {
            const month = window.location.pathname.split('/')[4];
            if (typeof month !== 'undefined') {
                return parseInt(month, 10);
            }
        }

        return (new Date().getMonth() + 1);
    }

    private getCurrentWeek(useInput: boolean = true): number {
        // if (useInput && document.querySelector('select#week')) {
        //     return parseInt((document.querySelector('select#week') as HTMLSelectElement).value, 10);
        // }
        if (this.getTypeOfStat() === 'weekly') {
            const week = window.location.pathname.split('/')[4];
            if (typeof week !== 'undefined') {
                return parseInt(week, 10);
            }
        }
        return this.getISOWeek(new Date()).weekNo;
    }

    private getCurrentDay(useInput: boolean = true): number {
        // if (useInput && document.querySelector('select#day')) {
        //     return parseInt((document.querySelector('select#day') as HTMLSelectElement).value, 10);
        // }
        if (this.getTypeOfStat() === 'daily') {
            const day = window.location.pathname.split('/')[4];
            if (typeof day !== 'undefined') {
                return parseInt(day, 10);
            }
        }
        return this.getDayOfYear(new Date());
    }

    private getDayOfYear(date: Date = new Date()) {
        const start: Date = new Date(date.getFullYear(), 0, 0); // Jan 0 = last day of previous year
        const diff = date.getTime() - start.getTime();
        const oneDay = 1000 * 60 * 60 * 24;
        return Math.floor(diff / oneDay);
    }

    private getISOWeek(date: Date): { isoYear: number; weekNo: number } {
        const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNum = d.getUTCDay() || 7;
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        const isoYear = d.getUTCFullYear();
        return {isoYear: isoYear, weekNo: weekNo};
    }

    private getYearsForSelect(): Array<number> {
        const fromYear = 2025;
        const currentYear = new Date().getFullYear() + 1;
        return Array.from({length: currentYear - fromYear + 1}, (_, i) => fromYear + i);
    }

    private getMonthsForSelect(): Array<number> {
        const currentYear = this.getCurrentYear();
        const d = new Date();
        const monthsNo = (currentYear === 2025) ? d.getMonth() + 1 : 12;

        return Array.from({length: monthsNo}, (_, i) => 1 + i);
    }

    private getWeeksForSelect(): Array<number> {
        const currentYear = this.getCurrentYear();
        const currentWeek = this.getISOWeekNumber(new Date());
        const weeksNo = (currentYear === 2025)
            ? currentWeek - 3 // since starting from week 4
            : currentWeek;

        const startWeek = (currentYear === 2025) ? 4 : 1;

        return Array.from({length: weeksNo}, (_, i) => startWeek + i);
    }

    private getDaysForSelect(): Array<number> {
        const currentYear = this.getCurrentYear();
        const currentDay = this.getDayOfYear(new Date());
        const weeksNo = (currentYear === 2025)
            ? currentDay - 21 // since starting from week 4
            : currentDay;

        const startWeek = (currentYear === 2025) ? 4 : 1;

        return Array.from({length: weeksNo}, (_, i) => startWeek + i);
    }

    private getISOWeekNumber(date: Date): number {
        const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNum = tempDate.getUTCDay() || 7;
        tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
        return Math.ceil((((tempDate.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
    }

    private getISOWeeksInYear(year: number): number {
        // ISO year has 53 weeks if Jan 1 is Thursday or a leap-year Wednesday
        const d = new Date(Date.UTC(year, 11, 31)); // Dec 31 of that year
        const day = d.getUTCDay() || 7;             // Sun→7, Mon→1, …
        return day === 4 || (this.isLeapYear(year) && day === 5) ? 53 : 52;
    }

    private isLeapYear(year: number) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    public sortTableViaHead() {
        if (this.tableHeadInit) {
            return;
        }
        this.tableHeadInit = true;

        document.querySelectorAll('thead th.sortable').forEach(th => {
            th.addEventListener("click", (event) => {
                if (this.requestInProgress) {
                    return;
                }

                const target = event.target as HTMLElement;
                let icon = target.tagName === 'I' ? target : target.querySelector('.bi'), sortDirection;

                if (icon === null) {
                    document.querySelectorAll('thead .bi').forEach(i => {
                        i.remove();
                    });
                    icon = document.createElement('i');
                    icon.classList.add('bi');
                    icon.classList.add('bi-sort-down');
                    target.append(icon);
                }

                if (icon.classList.contains('bi-sort-down')) {
                    icon.classList.add('bi-sort-down-alt');
                    icon.classList.remove('bi-sort-down');
                    sortDirection = true;
                } else {
                    icon.classList.add('bi-sort-down');
                    icon.classList.remove('bi-sort-down-alt');
                    sortDirection = false;
                }

                const table = th.closest("table") as HTMLTableElement;
                const columnIndex: number = Array.from((th.parentNode as HTMLTableSectionElement).children).indexOf(th);

                this.sortTable(table, columnIndex, sortDirection)
            });
        });
    }

    private sortTable(table: HTMLTableElement, columnIndex: number, sortDirection: boolean) {
        const tbody: HTMLTableSectionElement = table.querySelector("tbody") as HTMLTableSectionElement;
        const rows = Array.from(tbody.querySelectorAll("tr"));

        rows.sort((a, b) => {
            const cellA: number | string = (a.children[columnIndex] as HTMLTableCellElement).dataset.value || (a.children[columnIndex] as HTMLTableCellElement).textContent || '';
            const cellB: number | string = (b.children[columnIndex] as HTMLTableCellElement).dataset.value || (b.children[columnIndex] as HTMLTableCellElement).textContent || '';

            const A = cellA.replace(/^[\s.]+|[\s.]+$/g, "").toLowerCase();
            const B = cellB.replace(/^[\s.]+|[\s.]+$/g, "").toLowerCase();

            const numA = parseFloat(A);
            const numB = parseFloat(B);
            const isNumeric = !isNaN(numA) && !isNaN(numB);

            let result: number;
            if (isNumeric) {
                result = numA - numB;
            } else {
                result = A.localeCompare(B, undefined, {numeric: true, sensitivity: 'base'});
            }

            return sortDirection ? result : -result;
        });

        tbody.innerHTML = "";
        rows.forEach(function (row, index) {
            if (index <= 10) {
                row.style.display = 'table-row';
            } else {
                row.style.display = 'none';
            }
            tbody.appendChild(row);
        });

        sortDirection = !sortDirection; // toggle for next click
    }
}
